export default "__VITE_ASSET__BOP8Ds7w__"